import Decimal from 'decimal.js';
import { InvoiceIntegrationModel } from "../InvoiceIntegrationModel";
import { InvoiceAccountingIntegration } from "../InvoiceAccountingIntegration";
import { PaymentModel } from "../PaymentModel";
export function fromDTO(isVendor, dto) {
  return {
    id: dto.id,
    attachments: dto.attachments || [],
    netTerms: dto.netTerms,
    createdOn: dto.createdOn,
    issuedOn: dto.issuedOn,
    dueDate: dto.dueDate,
    customerId: dto.customerId,
    isRetryable: dto.isRetryable,
    pdfExists: dto.pdfExists,
    totalAmount: dto.totalAmount,
    paymentMethodStatus: dto.paymentMethodStatus,
    formattedNumber: dto.formattedNumber,
    status: isVendor ? dto.vendorStatus : dto.customerStatus,
    displayStatus: dto.displayStatus,
    paymentDisplayStatus: isVendor ? dto.vendorPaymentDisplayStatus : dto.customerPaymentDisplayStatus,
    isTotalAmountZero: dto.isTotalAmountZero,
    integration: InvoiceIntegrationModel.fromScoutDTO(dto.integration),
    items: dto.items,
    relationship: dto.relationship,
    rawTotalAmount: new Decimal(dto.rawTotalAmount).div(100).toDP(2),
    rawDueDate: new Date(dto.rawDueDate),
    rawIssuedOn: new Date(dto.rawIssuedOn),
    rawCreatedOn: new Date(dto.createdOn),
    number: dto.number,
    xeroIntegration: InvoiceAccountingIntegration.fromDTO(dto.xeroIntegration),
    payment: dto.payment ? new PaymentModel(dto.payment) : null
  };
}